import { UNMARK_DIRTY_QUESTION_BATCH } from "../types";

export default function(questions) {
  return {
    questions,
    type: UNMARK_DIRTY_QUESTION_BATCH
  };
}
